import React from 'react'

import { useTranslation } from 'react-i18next'

import { SectionGroup, SectionItem, SectionItemValue, SectionItemListaValores } from '@/components/ui'
import type { ResumoSimulacao } from '@/features/proposta/brasil/domain/ResumoProposta/resumo-simulacoes-proposta'

type TPropostaCompraContentSacocVParceladoProps = {
  resumo: ResumoSimulacao
}

export const PropostaCompraContentSacocVParcelado = ({ resumo }: TPropostaCompraContentSacocVParceladoProps) => {
  const { t } = useTranslation('proposta')

  return (
    <React.Fragment>
      <SectionGroup withBorder>
        <SectionItem
          label={t('resumo_proposta.proposta_compra.label.valor_total_proposta')}
          colSpan={6}
          withRightBorder
        >
          <SectionItemValue>{resumo.valorProposta}</SectionItemValue>
        </SectionItem>
        <SectionItem label={t('resumo_proposta.proposta_compra.label.forma_de_pagamento')} colSpan={6}>
          <SectionItemValue>{resumo.formaDePagamento}</SectionItemValue>
        </SectionItem>
      </SectionGroup>

      <SectionGroup withBorder>
        <SectionItem label={t('resumo_proposta.proposta_compra.label.poupanca')} colSpan={6} withRightBorder>
          <SectionItemValue>{resumo.valorPoupanca}</SectionItemValue>
        </SectionItem>

        <SectionItemListaValores
          label={t('resumo_proposta.proposta_compra.label.entrada')}
          valores={resumo.entrada}
          colSpan={6}
        />
      </SectionGroup>

      <SectionGroup withBorder>
        <SectionItemListaValores
          label={t('resumo_proposta.proposta_compra.label.mensais')}
          valores={resumo.mensais}
          colSpan={6}
          withRightBorder
        />
        <SectionItemListaValores
          label={t('resumo_proposta.proposta_compra.label.intermediarias')}
          valores={resumo.intermediarias}
          colSpan={6}
        />
      </SectionGroup>

      <SectionGroup>
        <SectionItemListaValores
          label={t('resumo_proposta.proposta_compra.label.pos_conclusao')}
          valores={resumo.posConclusao}
          colSpan={6}
          withRightBorder
        />
        <SectionItemListaValores
          label={t('resumo_proposta.proposta_compra.label.intermediarias_pos_conclusao')}
          valores={resumo.intermediariasPosConclusao}
          colSpan={6}
        />
      </SectionGroup>
    </React.Fragment>
  )
}
